import Client from '../HttpClient';

const baseUrl = '/admin/api/parameter';
const numbatUrl = '/gateway/numbat-api/api/vs/manage-config/sysParameter';
const list = () => {
	return Client.get(baseUrl);
};

const listByType = (type) => {
	return Client.get(`${baseUrl}/list-type/${type}`);
};
const listByTypeCloud = (merchantId, branchId, type) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/list-type/${type}`);
};
const find = (code) => {
	return Client.get(`${baseUrl}/${code}`);
};
const findCloud = (merchantId, branchId, code) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/get/${code}`);
};
const findCodeCloud = (merchantId, branchId, code) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/${code}`);
};
const create = (code, payload) => {
	return Client.post(`${baseUrl}${code ? `/${code}` : ''}`, payload);
};
const createCloud = (merchantId, branchId, code, payload) => {
	return Client.post(
		`${numbatUrl}/${merchantId}/${branchId}${code ? `/${code}` : ''}`,
		{ ...payload, merchantId, branchId }
	);
};
const update = (code, payload) => {
	return Client.put(`${baseUrl}/${code}`, payload);
};
const updateCloud = (merchantId, branchId, code, payload) => {
	return Client.put(
		`${numbatUrl}/${merchantId}/${branchId}/sysParameter/${code}`,
		payload
	);
};
const remove = (code) => {
	return Client.del(`${baseUrl}/${code}`);
};
const batch = (payload) => {
	return Client.put(`${baseUrl}/batch`, payload);
};
const manifest = (payload) => {
	return Client.put(`${baseUrl}/manifest`, payload);
};

const uploadFile = (code, payload) => {
	return Client.post(
		`${baseUrl}/member-image-form/${code} `,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};
const uploadFileCloud = (merchantId, branchId, code, payload) => {
	return Client.post(
		`${numbatUrl}/${merchantId}/${branchId}/member-image-form/${code} `,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

export default {
	list,
	listByType,
	find,
	create,
	update,
	remove,
	batch,
	manifest,
	uploadFile,
	findCloud,
	findCodeCloud,
	createCloud,
	updateCloud,
	listByTypeCloud,
	uploadFileCloud,
};
